export default __webpack_public_path__ + "static/media/zip.bf33e1b8.svg";